module.exports = __webpack_public_path__ + "static/media/as_item1_price2.fd4f83a0.png";